export default __webpack_public_path__ + "static/media/web.5b0d0abd.jpeg";